import type { Control, FieldValues } from 'react-hook-form';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { CheckBoxGroupProps } from './checkbox-group.component';
import CheckboxGroup from './checkbox-group.component';

export interface HfCheckBoxGroupProps<TFieldValues extends FieldValues = FieldValues> extends CheckBoxGroupProps {
  control: Control<TFieldValues>;
  name: string;
  multiSelectCheckboxType?: 'buttons' | 'checkboxes';
}

export default function HfCheckboxGroup<TFieldValues extends FieldValues = FieldValues>({
  id,
  control,
  name,
  label,
  data,
  value,
  textField,
  valueField,
  readOnly,
  required,
  onChange,
  fieldValueConverter,
  disabled,
  className,
  multiSelectCheckboxType = 'checkboxes',
  labelStyles,
  checkboxGroupStyling,
  archivedField,
  showSelectedArchivedOptions,
}: HfCheckBoxGroupProps<TFieldValues>) {
  return (
    <OdinController
      name={name}
      control={control}
      defaultValue={value}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <CheckboxGroup
          id={id}
          name={name}
          label={label}
          error={error?.message}
          value={value}
          onChange={onChange}
          textField={textField}
          valueField={valueField}
          data={data}
          readOnly={readOnly}
          required={required}
          disabled={disabled}
          className={className}
          multiSelectCheckboxType={multiSelectCheckboxType}
          labelStyles={labelStyles}
          checkboxGroupStyling={checkboxGroupStyling}
          archivedField={archivedField}
          showSelectedArchivedOptions={showSelectedArchivedOptions}
        />
      )}
    />
  );
}
